import { render, staticRenderFns } from "./UnsavedChangesWarning.vue?vue&type=template&id=37674e7a"
import script from "./UnsavedChangesWarning.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesWarning.vue?vue&type=script&lang=js"
import style0 from "./UnsavedChangesWarning.vue?vue&type=style&index=0&id=37674e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports